module.exports = __webpack_public_path__ + "static/media/archive-room.c98c2c6f.svg";